import { createI18n } from 'vue-i18n'
import az from './locales/az.json'
import en from './locales/en.json'
import tr from './locales/tr.json'
import ru from './locales/ru.json'

const messages = {
  az,
  en,
  tr,
  ru
}

// Get locale from localStorage or default to 'az'
const getLocale = () => {
  const savedLocale = localStorage.getItem('locale')
  return savedLocale && messages[savedLocale] ? savedLocale : 'az'
}

const i18n = createI18n({
  legacy: false,
  locale: getLocale(),
  fallbackLocale: 'az',
  messages
})

// Helper function to change locale
export const setLocale = (locale) => {
  if (messages[locale]) {
    i18n.global.locale.value = locale
    localStorage.setItem('locale', locale)
  }
}

export default i18n

